module.exports = __webpack_public_path__ + "media/images/b2b_admin/reports_mini_screen-6b7e8546731e4849fcc034ee1066c4ae.png";